import React, { Component, Fragment } from 'react';
import api from '../../../services/api';
import ModalConfirm from '../../common/modal-confirm';
import ModalAlert from '../../common/modal-alert';
import Pagination from '../../../components/Common/pagination';
class Permission extends Component {

    state = {
        load: false,
        sectors: {},
        erroDelete: false,
        insertSector: false,
        msgError: null,
        msgSuccess: null,
        nameSector: '',
        emailSector: '',
        idSector: null,
        classText: '',
        paginas:0
    }

    componentDidMount() {
        this.searchSectors();
    }

    searchSectors = async (e) => {
        let page = (e)?e.target.id:1;
        this.setState({ load: true });
        const response = await api.get(`/sectors?order_by=id&order_direction=DESC&page=${page}`);
        this.setState({ sectors: response.data.rows, load: false, paginas:Math.ceil(response.data.count/10) });
    }

    insertSector = () => {
        document.getElementById('nameSector').value = '';
        document.getElementById('emailSector').value = '';
        this.setState({ 
            insertSector: true, 
            msgError: null, 
            msgSuccess:null 
        });
    }

    createSector = async () => {
        let nameSector = document.getElementById('nameSector').value;
        let emailSector = document.getElementById('emailSector').value;

        try {

            let response = await api.post(`/sectors`, { name: nameSector, email: emailSector });
            this.searchSectors();
            document.getElementById('nameSector').value = '';
            document.getElementById('emailSector').value = '';
            this.setState({ msgError: null, msgSuccess: response.data.msg });

        } catch (err) {
            this.setState({ msgError: err.response.data.errors[0].msg, msgSuccess: null });
        }
    }

    updateStatus = async (e) => {
        const id = e.target.id;
        const value = (e.target.name == 1) ? 0 : 1;
        document.getElementById("modal-alert").click();
        try {
            const response = await api.put(`/sectors/${id}`, { status: value });
            this.searchSectors();
            this.setState({ msgAlert: response.data.msg, classText: "text-success" });
        } catch (err) {
            this.setState({ msgAlert: err.response.data.errors[0].msg, classText: "text-danger" });
        }
    }

    alterSector = (e) => {
        const id = e.target.id;
        const sector = this.state.sectors.filter((item) => (item.id == id));
        document.getElementById("nameSector").value = sector[0].name;
        document.getElementById("emailSector").value = sector[0].email;

        this.setState({
            msgError: null,
            msgSuccess: null,
            idSector: id,
            nameSector: sector[0].name
        });
    }

    confirmAlterSector = async (e) => {
        let nameSector = document.getElementById('nameSector').value;
        let emailSector = document.getElementById('emailSector').value;
        try {

            let response = await api.put(`/sectors/${this.state.idSector}`, { name: nameSector, email:emailSector });
            this.searchSectors();
            this.setState({ msgError: null, msgError: null, msgSuccess: response.data.msg });

        } catch (err) {
            this.setState({ msgError: err.response.data.errors[0].msg, msgSuccess: null });
        }
    }

    deleteSector = async (e) => {
        const id = e.target.id;
        if (id) {
            this.setState({ idSector: id, erroDelete: null });
            document.getElementById("modal-confirm").click();
        }
    }

    confirmDeleteSector = async () => {
        this.setState({ load: true });
        try {
            const response = await api.delete(`/sectors/${this.state.idSector}`);
            this.searchSectors();
            this.setState({ load: false, idSector: null, erroDelete: null });
            document.getElementById('close-modal-confirm').click();

            document.getElementById("modal-alert").click();
            this.setState({ msgAlert: response.data.msg, classText: "text-success" });

        } catch (err) {
            let msg = (err.response.data.errors) ? err.response.data.errors[0].msg : err.response.data.msg;
            this.setState({ erroDelete: msg });
        };
    }

    render() {
        return (
            <Fragment>
                <div className="row page-titles">
                    <div className="col-md-5 col-8 align-self-center">
                        <h3 className="text-themecolor">Setores
                        {(this.state.load) ? <i className="fa fa-spin fa-spinner"></i> : null}
                        </h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">

                            <div className="p-20 text-right">
                                <div className="col-md-2 btn btn-rounded btn-primary" data-toggle="modal" data-target=".modal-alter-document" onClick={this.insertSector}>Cadastrar</div>
                            </div>

                            <table className="table table-bodered">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Setor</th>
                                        <th>E-mail</th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(this.state.sectors.length) ?
                                        (this.state.sectors).map((item) => {
                                            return (
                                                <tr key={item.id}>
                                                    <td>{item.id}</td>
                                                    <td>{item.name}</td>
                                                    <td>{item.email}</td>
                                                    <td className="td-button" id={item.id}>
                                                        <div className="switch">
                                                            <label>
                                                                <input type="checkbox" defaultChecked={item.status} id={item.id} name={item.status} onChange={this.updateStatus} /><span className="lever"></span>
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td className="td-button">
                                                        <button type="button" id={item.id} onClick={this.alterSector} data-toggle="modal" data-target=".modal-alter-document" className="btn btn-sm btn-outline-success btn-circle">
                                                            <i id={item.id} className="fa fa-edit"></i>
                                                        </button>
                                                    </td>
                                                    <td className="td-button">
                                                        <button type="button" id={item.id} onClick={this.deleteSector} className="btn btn-sm btn-outline-danger btn-circle">
                                                            <i id={item.id} className="fa fa-times"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                        : null}
                                </tbody>
                            </table>

                            <Pagination function={this.searchSectors} paginas={this.state.paginas} />
                        </div>
                    </div>
                </div>

                <ModalConfirm title="Confirmação" msg="Tem certeza que deseja excluir o setor?" function={this.confirmDeleteSector} msgError={this.state.erroDelete} />
                <ModalAlert title="Informação" msg={this.state.msgAlert} function="" classText={this.state.classText} />

                <div className="modal fade modal-alter-document" data-backdrop="static" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="myLargeModalLabel">
                                    {(this.state.insertSector) ? 'Cadastrar ' : 'Alterar '}
                                    Setor
                                {(this.state.load) ? <i className="fa fa-spin fa-spinner"></i> : null}
                                </h5>
                                <button type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                            </div>
                            <div className="modal-body">
                                <form>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <span>Setor <i className="text-danger">*</i></span>
                                            <input type="text" id="nameSector" className="form-control" defaultValue={this.state.nameSector}></input>
                                        </div>
                                        <div className="col-md-12">
                                            <span>E-mail <i className="text-danger">*</i></span>
                                            <input type="email" id="emailSector" className="form-control" defaultValue={this.state.emailSector}></input>
                                        </div>
                                        {(this.state.msgError || this.state.msgSuccess) ?
                                            <div className="col-md-12 p-t-20">
                                                <div className={(this.state.msgSuccess) ? 'alert alert-success' : 'alert alert-danger'}>
                                                    {this.state.msgError}
                                                    {this.state.msgSuccess}
                                                </div>
                                            </div>
                                            : null}

                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                {(this.state.insertSector) ?
                                    <button className="col-md-2 btn waves-effect waves-light btn-rounded btn-success" onClick={this.createSector}>
                                        Cadastrar
                            </button>
                                    :
                                    <button className="col-md-2 btn waves-effect waves-light btn-rounded btn-success" onClick={this.confirmAlterSector}>
                                        Alterar
                                </button>
                                }

                                <button type="button" id="closeModalCreate" className="col-md-2 btn btn-secondary btn-rounded waves-effect" data-dismiss="modal">Fechar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment >
        )
    }

}

export default Permission;